import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035a5592"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-font-size mb--12"
}
const _hoisted_2 = {
  key: 1,
  class: "m-font-size mb--12"
}
const _hoisted_3 = { class: "user-support__form-ads" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "third-color mb--10" }, "Выбранные объявления:", -1))
const _hoisted_5 = {
  key: 0,
  class: "items-in-line flex-wrap flex-start"
}
const _hoisted_6 = { class: "user-support__form-file-input" }
const _hoisted_7 = {
  key: 0,
  class: "error-color xs-font-size"
}
const _hoisted_8 = { class: "center mt--20 gap--20" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Данные успешно сохранены", -1))

import { onMounted, Ref, ref, watch } from 'vue';
import {
  ErrorsType,
  FormPartnerProgramDataType,
  OptionsType,
  PartnerProgramType,
} from '@/types';
import { usePartnerProgramStore } from '@/store/modules/partnerProgram';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateForm',
  props: {
    isEdit: { type: Boolean, default: false },
    editProgram: { default: undefined }
  },
  emits: ['cancel'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const formData: Ref<FormPartnerProgramDataType> = ref({
  input_adverts_id: [],
  adverts_id: [],
  residentialComplexId: undefined,
  queueCompanyId: undefined,
  percent: '',
  start_action: '',
  end_action: '',
  images: undefined,
  files: undefined,
});

const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  adverts_id: { required },
  percent: { required },
  start_action: { required },
  end_action: { required },
};
const v$ = useVuelidate<FormPartnerProgramDataType>(rules, formData);
const errors: Ref<ErrorsType> = ref({});
const key: Ref<number> = ref(0);
const showSavedDataModal = ref(false);

const deleteAd = (option: { id: number; name: string }) => {
  formData.value.adverts_id = formData.value.adverts_id?.filter(
    el => el.id !== option.id,
  );
};
const chooseAd = (option: { id: number; name: string }) => {
  if (formData.value.adverts_id === undefined) {
    formData.value.adverts_id = [];
  }
  formData.value.adverts_id?.push(option);
};
const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const clearFormData = () => {
  v$.value.$reset();
  for (const [key] of Object.entries(formData.value)) {
    formData.value[key as keyof FormPartnerProgramDataType] = undefined;
  }
  key.value++;
};
const clearErrors = () => {
  errors.value = {};
};
const prepareDataForSend = (): FormData => {
  let sendData = new FormData();

  formData.value.adverts_id?.forEach(el => {
    sendData.append(`parameters[adverts_id][]`, String(el.id));
  });

  if (props.isEdit && props.editProgram) {
    sendData.append(`parameters[id]`, String(props.editProgram['id'].value));
  }

  sendData.append(`parameters[percent]`, String(formData.value.percent));
  sendData.append(
    `parameters[start_action]`,
    String(formData.value.start_action?.split(/\s/, 2)[0]),
  );
  sendData.append(
    `parameters[end_action]`,
    String(formData.value.end_action?.split(/\s/, 2)[0]),
  );

  if (formData.value.images) {
    Object.values(formData.value.images).forEach(val => {
      if (val !== null) {
        sendData.append('parameters[images][]', val);
      }
    });
  }

  return sendData;
};

const cancel = () => {
  emit('cancel');
};
const handleSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  try {
    isFormSaveLoading.value = true;
    let res;

    if (props.isEdit && props.editProgram) {
      res = await usePartnerProgramStore().updatePartnerProgram(
        prepareDataForSend(),
        +props.editProgram['id'].value,
      );
    } else {
      res = await usePartnerProgramStore().createPartnerProgram(prepareDataForSend());
    }

    if (res) {
      if (props.isEdit) {
        cancel();
      }
      showSavedDataModal.value = true;
      clearFormData();
      clearErrors();
      queueCategoryList.value = [];
      offerCardList.value = [];
      key.value++;
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error, 'parameters');
  } finally {
    isFormSaveLoading.value = false;
  }
};

const residentialComplexList: Ref<OptionsType[]> = ref([]);
const categoryMultiSelect: Ref<{ [key: number]: string }> = ref([]);
const queueCategoryList: Ref<OptionsType[]> = ref([]);
const offerCardList: Ref<OptionsType[]> = ref([]);
const isLoading = ref(false);
const isFormSaveLoading = ref(false);

const updateResidentialComplex = async (id: number) => {
  formData.value.input_adverts_id = undefined;
  formData.value.queueCompanyId = undefined;
  queueCategoryList.value = [];
  offerCardList.value = [];

  const res = await usePartnerProgramStore().getQueueList(id);

  if (res) {
    queueCategoryList.value = res.queue_category_name.map(el => {
      return {
        id: el.id,
        name: el.value,
      };
    });
  }
};

const updateQueueCategory = async (id: number) => {
  const res = await usePartnerProgramStore().getHousesList(id);

  if (res) {
    offerCardList.value = res.houses.map(el => {
      return {
        id: el.id,
        name: el.value,
      };
    });
  }
};

onMounted(async () => {
  try {
    isLoading.value = true;
    const res = await usePartnerProgramStore().getResidentialComplexes();

    if (res) {
      residentialComplexList.value = Object.entries(res.housingComplexes).map(el => {
        return {
          id: +el[0],
          name: el[1],
        };
      });
      categoryMultiSelect.value = res.categoryMultiSelect;
    }
  } finally {
    isLoading.value = false;
  }
});

watch(
  () => props.editProgram,
  () => {
    key.value++;
    if (props.isEdit && props.editProgram) {
      formData.value.percent = props.editProgram['percent'].value as string | undefined;
      formData.value.start_action = `${props.editProgram['start_action'].value} 01:00:00`;
      formData.value.end_action = `${props.editProgram['end_action'].value} 01:00:00`;

      const files = props.editProgram['files'].value as { id: number; name: string }[];

      if (Array.isArray(files)) {
        formData.value.files = files.map(el => {
          return {
            ...el,
            path: `${process.env.VUE_APP_API_AFFILIATE_PROGRAM_DOWNLOAD_ONE_FILE}?id=${el.id}`,
          };
        });
      }

      formData.value.adverts_id = (
        props.editProgram['ads'].value as { id: number; url: string }[]
      ).map(el => {
        return {
          id: el.id,
          name: categoryMultiSelect.value[el.id],
        };
      });
    } else {
      clearFormData();
    }
  },
  {
    deep: true,
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_date_picker = _resolveComponent("base-date-picker")!
  const _component_base_file_input = _resolveComponent("base-file-input")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_card, {
      class: "user-support",
      "full-width-mobile": ""
    }, {
      default: _withCtx(() => [
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Редактировать партнерскую программу "))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, "Создать партнерскую программу")),
        (_openBlock(), _createBlock(_component_base_form, {
          key: key.value,
          class: "user-support__form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_select_input, {
              modelValue: formData.value.residentialComplexId,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((formData.value.residentialComplexId) = $event)),
                updateResidentialComplex
              ],
              error: errors.value.residentialComplexId,
              options: residentialComplexList.value,
              height: "34",
              label: "Выберите ЖК",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('residentialComplexId'))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.residentialComplexId))
            }, null, 8, ["modelValue", "error", "options"]),
            _createVNode(_component_base_select_input, {
              modelValue: formData.value.queueCompanyId,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((formData.value.queueCompanyId) = $event)),
                updateQueueCategory
              ],
              disabled: queueCategoryList.value.length <= 0,
              error: errors.value.queueCompanyId,
              options: queueCategoryList.value,
              height: "34",
              label: "Выберите очередь",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('queueCompanyId'))),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.queueCompanyId))
            }, null, 8, ["modelValue", "disabled", "error", "options"]),
            _createVNode(_component_base_select_input, {
              modelValue: formData.value.input_adverts_id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.input_adverts_id) = $event)),
              disabled: offerCardList.value.length <= 0,
              error: errors.value.input_adverts_id,
              options: offerCardList.value,
              height: "34",
              "is-multi": "",
              label: "Выберите объявление",
              "show-check-all": "",
              onDeleteMultiSelectItem: deleteAd,
              onFocus: _cache[7] || (_cache[7] = ($event: any) => (delete errors.value.input_adverts_id)),
              onSelectMultiItem: chooseAd
            }, null, 8, ["modelValue", "disabled", "error", "options"]),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (formData.value.adverts_id?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.adverts_id, (ad) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: ad.id,
                        class: "user-support__form-ads-item center"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(ad.name), 1),
                        _createVNode(_component_base_icon, {
                          clickable: "",
                          color: "#94857d",
                          "font-size": "20",
                          name: "close",
                          onClick: ($event: any) => (deleteAd(ad))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass({ 'error-color': errors.value.adverts_id })
                  }, " Нет выбранных объявлений ", 2))
            ]),
            _createVNode(_component_base_input, {
              modelValue: formData.value.percent,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.percent) = $event)),
              error: errors.value.percent,
              invalid: !!errors.value.percent,
              height: "34",
              label: "Укажите % комиссии",
              onBlur: _cache[9] || (_cache[9] = ($event: any) => (validationErrorsHandlerByKey('percent'))),
              onFocus: _cache[10] || (_cache[10] = ($event: any) => (delete errors.value.percent)),
              onInput: _unref(v$).percent.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
            _createVNode(_component_base_date_picker, {
              modelValue: formData.value.start_action,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.start_action) = $event)),
              error: errors.value.start_action,
              height: "34",
              label: "Период действия от",
              onBlur: _cache[12] || (_cache[12] = ($event: any) => (validationErrorsHandlerByKey('start_action'))),
              onFocus: _cache[13] || (_cache[13] = ($event: any) => (delete errors.value.start_action)),
              onInput: _unref(v$).start_action.$touch
            }, null, 8, ["modelValue", "error", "onInput"]),
            _createVNode(_component_base_date_picker, {
              modelValue: formData.value.end_action,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.end_action) = $event)),
              error: errors.value.end_action,
              height: "34",
              label: "Период действия до",
              onBlur: _cache[15] || (_cache[15] = ($event: any) => (validationErrorsHandlerByKey('end_action'))),
              onFocus: _cache[16] || (_cache[16] = ($event: any) => (delete errors.value.end_action)),
              onInput: _unref(v$).end_action.$touch
            }, null, 8, ["modelValue", "error", "onInput"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_file_input, {
                modelValue: formData.value.images,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.images) = $event)),
                error: errors.value.images,
                files: formData.value.files,
                "with-delete-file": false,
                label: "Прикрепите файл",
                multiple: "",
                onBlur: _cache[18] || (_cache[18] = ($event: any) => (validationErrorsHandlerByKey('images'))),
                onFocus: _cache[19] || (_cache[19] = ($event: any) => (delete errors.value.images))
              }, null, 8, ["modelValue", "error", "files"]),
              (_ctx.isEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Внимание! При добавлении новых файлов, старые удалятся"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.isEdit)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                height: "36",
                "style-type": "coloredBorder",
                text: "Отмена",
                width: "165",
                onClick: cancel
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_base_button, {
            loading: isFormSaveLoading.value,
            height: "36",
            text: "Сохранить",
            type: "submit",
            width: "165",
            onClick: handleSubmit
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_component_base_info_modal, {
      key: key.value,
      "show-info-modal": showSavedDataModal.value,
      onClose: _cache[20] || (_cache[20] = ($event: any) => (showSavedDataModal.value = false))
    }, {
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 8, ["show-info-modal"]))
  ]))
}
}

})